import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import {
  MobileBody1,
  MobileBody2,
  MobileTitle1,
  WebBody1,
  WebBody2,
  WebTitle1,
} from "@/system/day/font/font";
import { swc, grayScale } from "@teamsparta/design-system";

export const Wrapper = styled.div`
  border: 1px solid ${swc.blue};
  border-radius: 8px;
  background-color: #f1f4ff;
  box-shadow: 0 8px 24px rgba(129, 137, 143, 0.12);
  padding: 24px;
  margin: 0 auto;
  width: 328px;
  height: 393px;
  ${DESKTOP} {
    width: 500px;
    height: 460px;
    padding: 30px;
  }
`;

export const Title = styled.div`
  ${MobileBody1};
  color: ${swc.blue} !important;
  ${DESKTOP} {
    text-align: center;
    ${WebBody1};
  }
`;

export const Desc = styled.div`
  ${MobileTitle1};
  padding-top: 8px;
  ${DESKTOP} {
    ${WebTitle1};
    text-align: center;
  }
`;

export const Image = styled.div`
  margin: 20px 0;
`;

export const Info = styled.p`
  ${MobileBody2};
  color: ${grayScale.gray80} !important;
  :nth-of-type(2) {
    padding-top: 20px;
  }
  ${DESKTOP} {
    ${WebBody2};
  }
`;
